<template>
    <div>
        <div class="common-form">规格类型</div>
        <div class="spec-box">
            <el-table
                :data="tableData"
                style="width: 100%"
                @row-click="rowClick"
                :cell-style="tableCellStyle">
                <el-table-column
                        prop="spec_name"
                        label="规格名称">
                    <template slot-scope="scope">
                    <span v-if="scope.row.edit">
                        <el-input size="small" v-model="scope.row.spec_name" @blur="handleInputBlur(scope.row)"></el-input>
                    </span>
                        <span v-else>{{scope.row.spec_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="80"
                        header-align="center"
                        align="center">
                    <template slot-scope="scope">
                        <el-button @click="clickDel(scope.row)" type="text" size="small" icon="el-icon-delete" v-auth="'/product/spec/delete'"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--添加-->
            <div class="add-box">
                <el-input
                        v-if="addShow"
                        ref="inputName"
                        placeholder="请输入类型名称 回车保存"
                        v-model="specName"
                        clearable
                        @keyup.enter.native="add"
                        @blur="closeAdd">
                </el-input>
            </div>
            <el-button type="text" icon="el-icon-plus" @click="openAdd">新增商品规格</el-button>
        </div>
    </div>
</template>

<script>
    import ProductApi from '@/api/product.js';
    import { deepClone } from '@/utils/base.js';

    export default {
        name: "Spce",
        data() {
            return {
                addShow: false,
                tableData: [],
                specName: '',
                highlightRow: 0
            };
        },
        mounted() {
            // 获取列表
            this.getData();
        },
        methods: {
            // 获取列表
            getData() {
                let self = this;

                ProductApi.specList({}, true)
                    .then(data => {
                        self.loading = false;
                        self.tableData = data.data.list;

                        if (self.highlightRow == 0) {
                            if (self.tableData.length > 0) {
                                this.$nextTick(() => {
                                    self.$emit('getSpecDetails',self.tableData[0].spec_id);
                                })
                                self.highlightRow = self.tableData[0].spec_id
                            }
                        }

                    })
                    .catch(error => {
                        self.loading = false;
                    });
            },

            // 打开添加input
            openAdd() {
                this.addShow = true
                this.$nextTick(() => {
                    this.$refs.inputName.focus()
                })
            },

            // 关闭添加input
            closeAdd() {
                this.addShow = false
                this.specName = ''
            },

            // 添加规格
            add() {
                let self = this;
                if (self.specName === '') {
                    self.$message('请填写规则名')
                    return false
                }
                const Params = {
                    spec_name: self.specName,
                }

                ProductApi.addSpec(Params)
                    .then(res => {
                        self.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        self.specName = ''
                        self.addShow = false
                        self.highlightRow = res.data.spec_id
                        self.$emit('getSpecDetails',res.data.spec_id);
                        self.getData();
                    }).catch(error => {

                    });
            },

            // 修改规格
            handleInputBlur (row) {
                row.edit = false
            },

            // 删除规格
            clickDel(row) {
                let self = this;
                self.$confirm('删除后不可恢复，确认删除该规格吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    ProductApi.specDel({
                        spec_id: row.spec_id
                    }).then(res => {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        if (self.tableData.length > 0){
                            this.$nextTick(() => {
                                self.$emit('getSpecDetails',self.tableData[0].spec_id);
                            })
                            self.highlightRow = self.tableData[0].spec_id
                        }
                        self.getData();
                    }).catch(error => {

                    });
                }).catch(error => {
                    console.log(error)
                });
            },

            // 表格行选中颜色
            tableCellStyle (row, rowIndex, column) {
                if (this.highlightRow === row.row.spec_id) {
                    return 'background-color:oldlace;'
                } else {
                    return 'background-color:#fff;'
                }
            },

            // 点击行,打开关联规格值列表
            rowClick(row, column, event) {
                this.highlightRow = row.spec_id;
                this.$emit('getSpecDetails',row.spec_id);
            },
        }
    }
</script>

<style scoped>
    .spec-box{
        padding: 0 10px;
    }
    .common-form {
        position: relative;
        height: 40px;
        padding-left: 20px;
        line-height: 40px;
        font-size: 16px;
        font-weight: 700;
        margin: 10px 0;
        border-bottom: 1px solid #bababa;
    }
    .common-form:before {
        margin-left: 10px;
    }
    .add-box{
        margin-top: 15px;
    }
</style>
<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }
</style>
<!--<style>
    /* 用来设置当前页面element全局table的内间距 */
    .el-table__row td{
        padding: 0;
    }
    /* 用来设置当前页面element全局table 选中某行时的背景色*/
    .el-table__body tr.current-row>td{
        background-color: #f19944 !important;
        /* color: #f19944; */  /* 设置文字颜色，可以选择不设置 */
    }
    /* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
    .el-table&#45;&#45;enable-row-hover .el-table__body tr:hover>td {
        background-color: #f19944;
        /* color: #f19944; */ /* 设置文字颜色，可以选择不设置 */
    }
</style>-->



// WEBPACK FOOTER //
// src/views/product/spec/Spec.vue